<template>
  <div class="home">
    <carousel />
    <el-row class="fixed_width">
      <el-row type="flex"
              align="middle">
        <el-col :xs="9"
                :sm="12">
          <img src="@/assets/images/home1.png"
               style="width: 5.16rem; max-width: 100%;">
        </el-col>
        <el-col class="article"
                :xs="13"
                :sm="{span: 12, offset: 0}">
          <div class="article-title">{{$t('home.ev')}}</div>
          <div class="article-content">{{$t('home.evContent')}}</div>
          <div class="more">
            <span v-on:click="goto('ev')">More </span>
            <i class="el-icon-right"></i>
          </div>
        </el-col>
      </el-row>
    </el-row>
    <!-- 添加背景 -->
    <div style="width: 100%; background: #F9F9F9;">
      <el-row class="fixed_width">
        <el-row type="flex"
                align="middle">
          <el-col class="article"
                  :xs="13"
                  :sm="12">
            <div class="article-title">{{$t('home.salvageValue')}}</div>
            <div class="article-content">{{$t('home.salvageValueContent')}}</div>
            <div class="more">
              <span v-on:click="goto('salvageValue')">More </span>
              <i class="el-icon-right"></i>
            </div>
          </el-col>
          <el-col :xs="9"
                  :sm="{span: 12, offset: 0}">
            <img src="@/assets/images/home2.png"
                 style="width: 5.16rem; max-width: 100%;">
          </el-col>
        </el-row>
      </el-row>
    </div>
    <el-row class="fixed_width"
            style="backgroud: #F9F9F9">
      <el-row type="flex"
              align="middle">
        <el-col :xs="9"
                :sm="12">
          <img src="@/assets/images/home3.png"
               style="width: 5.16rem; max-width: 100%;">
        </el-col>
        <el-col class="article"
                :xs="13"
                :sm="{span: 12, offset: 0}">
          <div class="article-title">{{$t('home.secondHand')}}</div>
          <div class="article-content">{{$t('home.secondHandContent')}}</div>
          <div class="more">
            <span v-on:click="goto('secondHand')">More </span>
            <i class="el-icon-right"></i>
          </div>
        </el-col>
      </el-row>
    </el-row>

    <!-- 添加背景 -->
    <div style="width: 100%; background: #F9F9F9;">
      <el-row class="youshi fixed_width">
        <div class="youshi-title">{{$t('home.youshi')}}</div>
        <el-row class="youshi-content"
                type="flex">
          <el-col :xs="12"
                  :md="6">
            <img src="@/assets/images/home4-1.png">
            <div class="youshi-subtitle">{{$t('home.youshititle1')}}</div>
            <div class="youshi-font">{{$t('home.youshifont1_1')}}</div>
            <div class="youshi-font">{{$t('home.youshifont1_2')}}</div>
            <div class="youshi-font">{{$t('home.youshifont1_3')}}</div>
            <div class="youshi-footer"></div>
          </el-col>
          <el-col :xs="12"
                  :md="6">
            <img src="@/assets/images/home4-2.png">
            <div class="youshi-subtitle">{{$t('home.youshititle2')}}</div>
            <div class="youshi-font">{{$t('home.youshititle2_1')}}</div>
            <div class="youshi-font">{{$t('home.youshititle2_2')}}</div>
            <div class="youshi-font">{{$t('home.youshititle2_3')}}</div>
            <div class="youshi-footer"></div>
          </el-col>
          <el-col :xs="12"
                  :md="6">
            <img src="@/assets/images/home4-3.png">
            <div class="youshi-subtitle">{{$t('home.youshititle3')}}</div>
            <div class="youshi-font">{{$t('home.youshititle3_1')}}</div>
            <div class="youshi-font">{{$t('home.youshititle3_2')}}</div>
            <div class="youshi-font">{{$t('home.youshititle3_3')}}</div>
            <div class="youshi-footer"></div>
          </el-col>
          <el-col :xs="12"
                  :md="6">
            <img src="@/assets/images/home4-4.png">
            <div class="youshi-subtitle">{{$t('home.youshititle4')}}</div>
            <div class="youshi-font">{{$t('home.youshititle4_1')}}</div>
            <div class="youshi-font">{{$t('home.youshititle4_2')}}</div>
            <div class="youshi-font">{{$t('home.youshititle4_3')}}</div>
            <div class="youshi-footer"></div>
          </el-col>
        </el-row>
      </el-row>
    </div>
  </div>
</template>

<script>
import Carousel from './carousel'
export default {
  components: {
    Carousel
  },
  data() {
    return {}
  },
  methods: {
    goto(path) {
      this.$router.push({ path })
    },
    changeImage(value) {
      // console.log('change image', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  .fixed_width {
    // width: 1200px;
    max-width: 1200px;
    margin: 0 auto;
    img {
      width: 100%;
    }

    .el-row {
      padding: 60px 0px;
    }
  }

  .article {
    text-align: left;
    // &.right {
    //   text-align: right !important;
    // }
    margin: 0rem 0.5rem;
    .article-title {
      font-size: 0.24rem;
      font-weight: 500;
      color: rgba(27, 27, 27, 1);
      line-height: 0.36rem;
      border-bottom: 0.01rem solid #c9c9c9;
      padding-bottom: 0.15rem;
      line-height: 0.39rem;
    }

    .article-content {
      font-size: 0.16rem;
      font-weight: 400;
      color: rgba(156, 156, 156, 1);
      line-height: 0.26rem;
      margin: 0.15rem 0rem;
    }

    .more {
      font-size: 0.22rem;
      font-weight: 400;
      color: rgba(58, 171, 250, 1);
      line-height: 0.33rem;
      cursor: pointer;
    }
  }

  .youshi {
    img {
      width: 1.7rem;
    }

    .el-row {
      padding: 0px 0px 60px 0px;
    }
    .el-col {
      margin-top: 0.6rem;
      padding-bottom: 0.6rem;
      position: relative;
    }
    .youshi-title {
      font-size: 0.34rem;
      font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
        "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
        "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol";
      font-weight: 500;
      color: rgba(27, 27, 27, 1);
      line-height: 0.48rem;
      margin-top: 0.7rem;
    }

    // .youshi-content {
    //   margin: 1rem 0rem;
    // }

    .youshi-subtitle {
      font-size: 0.22rem;
      font-weight: 500;
      color: rgba(27, 27, 27, 1);
      margin-top: 0.15rem;
      line-height: 0.33rem;
    }

    .youshi-font {
      font-size: 0.16rem;
      font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
        "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
        "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol";
      font-weight: 400;
      color: rgba(133, 133, 133, 1);
      line-height: 0.24rem;
      margin: 0.1rem 0;
    }

    .youshi-footer {
      height: 0.03rem;
      width: 1rem;
      background: #bfe5ff;
      position: absolute;
      bottom: 0px;
      left: 50%;
      transition: tranlateX(-50%);
      transform: translateX(-50%);
    }
  }

  @media only screen and (max-width: 750px) {
    .fixed_width {
      .el-row {
        padding: 0.6rem 0px;
      }
    }

    .article {
      margin: 0px 0.24rem;
      // &.right {
      //   text-align: right !important;
      //   padding-left: 0px;
      // }
      .article-title {
        line-height: 0.39rem;
        font-size: 0.26rem;
        margin: 0.15rem 0rem;
        padding-bottom: 0.15rem;
      }

      .article-content {
        font-size: 0.17rem;
        line-height: 0.26rem;
        margin-top: 0.25rem;
        margin-bottom: 0.15rem;
      }

      .more {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.36rem;
      }
    }

    .youshi {
      .el-row {
        padding: 0rem 0rem 0.6rem 0rem;
      }
      .el-col {
        margin-top: 0.6rem;
        padding-bottom: 0.6rem;
        position: relative;
      }
      .youshi-title {
        font-size: 0.34rem;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
          "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
          "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 500;
        color: rgba(27, 27, 27, 1);
        line-height: 0.48rem;
        margin-top: 0.7rem;
      }

      .youshi-content {
        flex-wrap: wrap;
      }

      .youshi-subtitle {
        font-size: 0.22rem;
        font-weight: 500;
        color: rgba(27, 27, 27, 1);
        line-height: 0.33rem;
      }

      .youshi-font {
        font-size: 0.16rem;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont,
          "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
          "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 400;
        color: rgba(133, 133, 133, 1);
        line-height: 0.24rem;
        margin: 0.1rem 0;
      }

      .youshi-footer {
        height: 0.03rem;
        width: 1rem;
        background: #bfe5ff;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transition: tranlateX(-50%);
        transform: translateX(-50%);
      }
    }
  }
}
</style>
